var React = require('react');

function SChevronnext18Light (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.5,9a1.23486,1.23486,0,0,0-.38531-.894l-6.992-6.749A1.247,1.247,0,0,0,5.3693,3.13066l6.083,5.87178L5.38913,14.84956A1.248,1.248,0,0,0,6.24988,17a1.20463,1.20463,0,0,0,.85765-.343l7.01-6.75513A1.24976,1.24976,0,0,0,14.5,9Z","fill":"#fff"}));
}

SChevronnext18Light.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SChevronnext18Light;

SChevronnext18Light.default = SChevronnext18Light;
